<template>

    <trax-ui-card align="center" background-color="primary">

        <h2>{{ lang.polaris.form.save_all }}</h2>

        <button type="button" class="btn btn-round btn-lg btn-white text-primary mb-3" @click="saveAll">
            {{ lang.polaris.form.save }}
        </button>

    </trax-ui-card>

</template>

<script>
    export default {
    
        data: function() {
            return {
                id: 'trax-account-user-edit',
                lang: lang,
                bus: this.$bus
            }
        },

        methods: {

            saveAll() {
                this.bus.$emit(this.id+'-errors', {});
                this.bus.$emit(this.id+'-1-save-all', {});
            }
        }
    }
</script>
